<template>
  <!-- Contact視窗 -->
  <ui-modal ref="contactUsModal" content-class="contact-us-dialog" :forcing="true" :header-title="headerTitle" :hide-overlay="false">
    <v-sheet class="contact-us-container" min-height="142" max-height="60vh">
      <p class="contact-us-text">{{ contactUsText }}</p>
    </v-sheet>
  </ui-modal>
</template>

<script>
import UiModal from '@/components/dialog/ui-modal'

export default {
  name: 'ContactUsModal',
  components: {
    UiModal,
  },
  data() {
    return {}
  },
  computed: {
    headerTitle() {
      return this.$t('contact_title')
    },
    contactUsText() {
      return 'mycs@myfunnow.com'
    },
  },
  mounted() {},
  methods: {
    showModal() {
      this.$refs.contactUsModal.showModal()
    },
    hideModal() {
      this.$refs.contactUsModal.hideModal()
    },
  },
}
</script>

<style scoped lang="scss">
.contact-us-container {
  padding: 12px 20px 24px;
  overflow-y: auto;

  .contact-us-text {
    white-space: break-spaces;
  }
}
</style>
